// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"c7651475","367":"2f22eddd"}[chunkId] + ".chunk.css";
};